

import { BUSINESS_API } from "../constants/api";
import { getHeadersWithTokenOnly, getUrl, optionsGet } from "./commonService";
import customAxios from "./customAxios";

export default class BusinessService {

  getBusinessService(params:any) {
   
    const url = getUrl(BUSINESS_API.INFO);
    const headers =getHeadersWithTokenOnly(params);
    const options:any = optionsGet(url, headers);

    return customAxios(options).then((res) => {
      return res.data;
    });


  }
}
